@if (posts().length > 0) {
  <section class="sav-journal-grid-section" aria-label="Insights and perspectives">
    <div class="sav-journal-grid-wrap">
      <!-- <h2>, not <h3>: this is a top-level section heading like every other one on the page.
           As an <h3> it rendered a step down the type scale and looked inconsistent. -->
      <div class="sav-journal-grid-head">
        <h2>{{ heading }}</h2>
        <p>{{ description }}</p>
      </div>

      @if (showTabs) {
        <div
          class="sav-premium-collection-tabs sav-journal-grid-tabs"
          role="tablist"
          aria-label="Insight categories"
        >
          @for (tab of tabs(); track tab.id) {
            <button
              type="button"
              role="tab"
              [class.active]="selectedTabId() === tab.id"
              [attr.aria-selected]="selectedTabId() === tab.id"
              (click)="selectTab(tab.id)"
            >
              {{ tab.label }}
            </button>
          }
        </div>
      }

      @if (visiblePosts().length === 0) {
        <div class="sav-journal-empty-state mt-10">
          <span class="sav-journal-empty-icon" aria-hidden="true">📰</span>
          <p>No posts found in this category yet.</p>
        </div>
      } @else {
        <!-- Shared blog card + grid: 4 per row. -->
        <div class="sav-blog-grid mt-10 md:mt-12">
          @for (post of posts(); track post.id) {
            <app-blog-post-card
              [post]="{
                articlePath: post.path,
                title: post.title,
                excerpt: post.excerpt,
                imageUrl: post.imageUrl,
                category: post.category,
                readTime: post.readTime,
                author: post.author,
                storeLogoUrl: post.storeLogoUrl,
              }"
            />
          }
        </div>
      }
    </div>
  </section>
}
